import cn from 'classnames';

import Logos from '@/svg/logos.svg';

type DefaultLogoReelProps = {
  showPretext?: boolean;
  className?: string;
  pretext?: string;
};

export function DefaultLogoReel({
  showPretext = true,
  pretext,
  className,
}: DefaultLogoReelProps) {
  return (
    <div className={cn(`mx-auto max-w-full px-6 text-center`, className)}>
      {showPretext && (
        <p className="mb-8 text-lg font-semibold text-haiti">
          {pretext ||
            `Trusted by teams of all sizes to deliver content to millions across the world`}
        </p>
      )}
      <Logos className="mx-auto block max-w-full" />
    </div>
  );
}
